<template>
  <patient-demographics-base-dialog
    :patient="{}"
    :demographics="{}"
    title="Create Patient"
    @save="onSave"
    @duplicatePatientsFound="duplicatePatientsFound"
  >
    <template v-if="hasAnyPermission('PATIENT_CREATE')" #dialog-activator="{ openDialog }">
      <v-list-item-content class="px-4" @click.stop="openDialog">New Patient</v-list-item-content>
    </template>
    <template v-slot:errors>
      <div v-if="hasDuplicatePatients" class="error--text ma-3">
        There is already a patient(s) in VIPER with this Name and Date of Birth:
        <div v-for="patient in duplicatePatients" :key="patient.id">
          <router-link
            :to="{
              name: 'patient-demographics',
              params: { orgId: patient.organization.id, patientId: patient.id }
            }"
            target="_blank"
            >{{ patient.externalId }} {{ patient.lastName }}, {{ patient.firstName }}</router-link
          >
        </div>
      </div>
    </template>
  </patient-demographics-base-dialog>
</template>

<script>
import _ from 'lodash'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import PatientDemographicsBaseDialog from '@/components/demographics/PatientDemographicsBaseDialog'
import { patientDemographicsService } from '@/services/patient-demographics-service'
import { patientService } from '@/services/patient-service'
import { permissionsMixin } from '@/mixins/permissions'

export default {
  components: { PatientDemographicsBaseDialog },
  mixins: [permissionsMixin],
  data() {
    return {
      duplicatePatients: []
    }
  },
  computed: {
    activeOrg() {
      return MyActiveOrganization
    },
    orgId() {
      return MyActiveOrganization.id
    },
    hasDuplicatePatients() {
      return !_.isEmpty(this.duplicatePatients)
    }
  },
  methods: {
    async onSave(form) {
      form.demographics.patient = await this.createPatient(form.patient)
      await patientDemographicsService.create(this.orgId, form.demographics)
      this.redirectToPatient(form.demographics.patient.id)
      this.$emit('save')
    },
    async createPatient(patient) {
      const updatedPatient = _.merge(patient, { organization: this.activeOrg })
      const { data } = await patientService.create(updatedPatient)
      return data
    },
    redirectToPatient(patientId) {
      this.$router.push({
        name: 'patient-demographics',
        params: { orgId: this.orgId, patientId: patientId }
      })
    },
    duplicatePatientsFound(patients) {
      this.duplicatePatients = patients
    }
  }
}
</script>
